import React, { useState, useEffect } from 'react';
import { Card, Upload, Button, message, Row, Col, Input, List, Pagination } from 'antd';
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons';
import axios from 'axios';

const CCerealesCliente = () => {
  const [precioCereales, setPrecioCereales] = useState(null);
  const [precioPromSoja, setPrecioPromSoja] = useState('');
  const [loading, setLoading] = useState(false);
  const [empresaData, setEmpresaData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const { TextArea } = Input;

  const user = JSON.parse(localStorage.getItem('user'));
  const empresaId = user?.user?.idCooperativa;


  useEffect(() => {
    const fetchEmpresaData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`);
        setEmpresaData(response.data);
        const precioPromedioSoja = response.data?.cereales?.[0]?.[0]?.precioPromSoja || '';
        setPrecioPromSoja(precioPromedioSoja);
      } catch (error) {
        console.error('Error al cargar datos de la empresa:', error);
        message.error('Error al cargar los datos de la empresa');
      }
    };

    if (empresaId) {
      fetchEmpresaData();
    }
  }, [empresaId]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        message.error('Solo se permiten archivos PDF.');
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('El archivo debe ser menor a 5MB.');
        return false;
      }
      setPrecioCereales(file);
      return false;
    },
    fileList: precioCereales ? [precioCereales] : [],
  };

  const handleUpload = async () => {
    if (!precioCereales && !precioPromSoja) {
      message.warning('Por favor selecciona un archivo PDF o ingresa un precio antes de subir.');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('section', 'cereales');

    if (precioCereales) {
      formData.append('precioCereales', precioCereales);
    }
    if (precioPromSoja) {
      formData.append('precioPromSoja', precioPromSoja);
    }

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      message.success('Datos actualizados exitosamente.');
      setEmpresaData(response.data);
      setPrecioCereales(null);
      setPrecioPromSoja(response.data?.cereales?.[0]?.precioPromSoja || '');
    } catch (error) {
      console.error('Error al actualizar los datos:', error);
      message.error('Hubo un error al subir los datos.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const renderPDFPreview = (file) => {
    if (file) {
      return (
        <div className="pdf-preview">
          <FilePdfOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />
          <p>{file.name}</p>
        </div>
      );
    }
    return null;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const historialPrecioCereales = empresaData?.cereales?.[0]?.historialPrecioCereales?.slice()
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha)) || [];

  const paginatedData = historialPrecioCereales.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return (
    <div className="p-4">
      <Card title="Cereales" className="mb-4">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card title="Historial Precio Cereales">
              <Upload {...uploadProps} accept=".pdf">
                <Button style={{ marginBottom: '10px' }} icon={<UploadOutlined />}>Seleccionar PDF</Button>
              </Upload>
              <List
                size="small"
                bordered
                dataSource={paginatedData}
                renderItem={(item) => (
                  <List.Item
                    actions={[<Button type="link" onClick={() => window.open(`${process.env.REACT_APP_S3_URL}/${item.precioCereal}`, '_blank')}>Ver PDF</Button>]}
                  >
                    <List.Item.Meta
                      avatar={<FilePdfOutlined style={{ fontSize: '24px', color: '#1890ff' }} />}
                      title={new Date(item.fecha).toLocaleDateString('es-ES')}
                    />
                  </List.Item>
                )}
              />
              <Pagination
                current={currentPage}
                pageSize={itemsPerPage}
                total={historialPrecioCereales.length}
                onChange={handlePageChange}
                style={{ marginTop: '16px', textAlign: 'center' }}
              />
            </Card>
          </Col>

          <Col span={12}>
            <Card title="Precio Promedio de Soja">
              <TextArea
                rows={4}
                style={{ width: '100%', marginTop: '16px' }}
                placeholder="Escribe el precio promedio de soja aquí"
                value={precioPromSoja || ''}
                onChange={(e) => setPrecioPromSoja(e.target.value)}
              />
            </Card>
          </Col>
        </Row>

        <Button
          type="primary"
          onClick={handleUpload}
          loading={loading}
          disabled={!precioCereales && !precioPromSoja}
          className="mt-4"
          style={{ marginTop: '16px' }}
        >
          Actualizar
        </Button>
      </Card>
    </div>
  );
};

export default CCerealesCliente;